import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'currency', standalone: true })
@Injectable({providedIn: 'root'})
export class CurrencyPipe implements PipeTransform {
	
	symbols: any = {
		'EUR': '€',
		'USD': '$',
		'GBP': '£',
		'PLN': 'zł',
		'RUB': '₽',
		'SEK': 'kr',
		'DKK': 'kr.',
		'NOK': 'kr'
	};
	
	transform(value) {
		return this.symbols[value] || '';
	}
	
}